import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Chris Litherland
 * id 36F33522-9167-42DD-BA0A-8920F480F38C
 * name headset-dock
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/headset-dock.svg
 * tags
 * - Audio 
 */
export const HeadsetDockIcon = createSvgIcon(<><path d="M2,18H9V6.13C7.27,6.57 6,8.14 6,10V11H8V17H6A2,2 0 0,1 4,15V10A6,6 0 0,1 10,4H11A6,6 0 0,1 17,10V12H18V9H20V12A2,2 0 0,1 18,14H17V15A2,2 0 0,1 15,17H13V11H15V10C15,8.14 13.73,6.57 12,6.13V18H22V20H2V18Z" /></>, 'HeadsetDockIcon');
export default HeadsetDockIcon